import { useMutation } from "@tanstack/react-query";
import api from "api/landlord/auth";
import { useNavigate } from "react-router-dom";

import { getErrorMessage } from "utils/error";
import { Button, ButtonSize, ButtonVariant, Input } from "shared/components";
import { useForm } from "shared/hooks/use-form";
import { login } from "./validations";
import { toast } from "react-toastify";
import logoSquare from "shared/branding/logo-square.svg";

export const ForgotPassword = () => {
  const navigate = useNavigate();

  const { values, register, isSubmitting, onSubmit } = useForm(
    {
      email: ""
    },
    login
  );

  const { mutate } = useMutation({
    mutationFn: (email: string) => {
      return api.resetPassword(email);
    },
    onSuccess: () => {
      toast.success(
        "Instructions to reset your password will be sent to you. Please check your email"
      );
      navigate("/login");
    },
    onError: (err) => {
      toast.error(getErrorMessage(err));
    }
  });

  return (
    <div className="animate-appear flex min-h-screen items-center justify-center bg-background-900 p-2">
      <div className="h-full rounded-lg border border-alpha-100 bg-background-1000 p-8 shadow-xl lg:min-w-[400px]">
        <div className="flex items-center gap-4">
          <img alt="Boom logo" className="h-10 w-10" src={logoSquare} />
          <div>
            <p className="text-base font-bold">Boom</p>
            <p className="text-sm font-medium text-content-200">
              for Property Managers
            </p>
          </div>
        </div>
        <div className="my-6 border-b border-alpha-40" />
        <p className="mb-2 text-xl font-bold text-content-1000">
          Reset Password
        </p>
        <p className="mb-6 whitespace-pre-line text-sm font-medium text-content-400">
          {`Enter your email below and we will send you${"\n"} your login credentials`}
        </p>
        <form
          onSubmit={onSubmit({
            onSuccess: () => mutate(values.email)
          })}
        >
          <Input
            id="email"
            label="Email"
            placeholder="example@gmail.com"
            required={true}
            {...register("email")}
          />
          <Button
            variant={ButtonVariant.PRIMARY}
            size={ButtonSize.BASE}
            type="submit"
            className="mb-2 mt-6 w-full"
            loading={isSubmitting}
          >
            Reset Password
          </Button>
          <Button className="w-full" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </form>
      </div>
    </div>
  );
};
